import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./msalConfig";
import { IS_DEV_AUTH } from "./AuthProvider";
import { useDevAuth } from "./DevAuthProvider";
import { DEV_USERS } from "./devUsers";

export interface AuthUser {
  oid: string;
  email: string;
  name: string;
  isAuthenticated: boolean;
}

interface AuthApi {
  user: AuthUser | null;
  isAuthenticated: boolean;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
}

function useAuthDev(): AuthApi {
  const { email, signOut } = useDevAuth();
  const meta = DEV_USERS.find((u) => u.email === email);
  const user: AuthUser = {
    oid: `dev:${email}`,
    email,
    name: meta?.name ?? email.split("@")[0],
    isAuthenticated: true,
  };
  return {
    user,
    isAuthenticated: true,
    signIn: async () => { /* trocar via DevUserBadge */ },
    signOut: async () => signOut(),
  };
}

function useAuthProd(): AuthApi {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = accounts[0];
  const user: AuthUser | null = account
    ? {
        oid:
          (account.idTokenClaims?.oid as string | undefined) ??
          account.localAccountId,
        email:
          account.username ??
          ((account.idTokenClaims?.preferred_username as string) ?? ""),
        name: account.name ?? "",
        isAuthenticated: true,
      }
    : null;
  return {
    user,
    isAuthenticated,
    signIn: async () => {
      await instance.loginRedirect(loginRequest);
    },
    signOut: async () => {
      await instance.logoutRedirect({
        account: account ?? undefined,
        postLogoutRedirectUri: window.location.origin,
      });
    },
  };
}

/**
 * Hook unificado de auth, fixado em tempo de import baseado em VITE_AUTH_MODE.
 * Ambos os ramos chamam o MESMO conjunto de hooks (sem condicional dentro do
 * corpo da função), o que respeita Rules of Hooks.
 */
export const useAuth: () => AuthApi = IS_DEV_AUTH ? useAuthDev : useAuthProd;
